import { FilterKeyVal } from 'pages/NewDashboard/components/CommonDrawers/CreateNewList/KeyLabelFilterDrawer/components/RenderKeyValues/types'
import { FILTER_OPTION } from 'services/Api/StaffLinkApiFolder/type'

export interface ITagFilterState {
  drawers: {
    showTagFilterDrawer: boolean
    showKeyLabelFilterDrawer: boolean
  }
  selectedTagsFilter: string[]
  selectedTagsFilterType: FILTER_OPTION
  buttonType: 'save_and_apply' | 'apply' | ''
  showSave: boolean
  selectedLabelKeyValues: FilterKeyVal[]
}

export interface IKeyLabelFilterPayload {
  buttonType?: 'save_and_apply' | 'apply'
  drawerStatus?: boolean
  showSave?: boolean
  selectedLabelKeyValues: FilterKeyVal[]
}

export enum FilterEntityEnum {
  ETY_UNKNOWN = 0,
  CUSTOMER = 1,
  INVENTORY = 2,
  INVOICE = 3,
  ORDER = 4
}

export interface IFilterByLabelKeyPayload {
  entity: FilterEntityEnum
  filter_key_vals: FilterKeyVal[]
}
